import { ReactElement, useCallback } from 'react';
import {
  TeacherAttendanceLoaderQuery,
  TeacherAttendanceResponse,
} from '../types';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import { getTeacherAttendance } from '../api';

export interface TeacherAttendanceLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  TeacherAttendanceLoaderQuery,
  TeacherAttendanceResponse
>();

export function useTeacherAttendance() {
  const context = useFetch();
  return {
    data: context.data,
    query: context.query,
    loading: context.loading,
    updateQuery: context.updateQuery,
    refresh: context.refresh,
    error: context.error,
  };
}

export const TeacherAttendanceLoaderConsumer = FetchConsumer;

export const ITEMS_PER_PAGE_DEFAULT = 10;
export const PAGE_INITIAL_DEFAULT = 1;

export function TeacherAttendanceLoader({
  children,
}: TeacherAttendanceLoaderProps) {
  const request = useCallback((query: TeacherAttendanceLoaderQuery) => {
    return getTeacherAttendance(
      query.items,
      query.page - 1,
      query.sectionId,
      query.classStatus,
    );
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{
        items: ITEMS_PER_PAGE_DEFAULT,
        page: PAGE_INITIAL_DEFAULT,
      }}
      fetchImmediately={true}
      children={children}
    />
  );
}
